var multimap = new function(){

	var me = this;
	this.map;
	this.startZoom = 6,
	this.globalStateZoom = 7,
	this.globalTownZoom = 8,
	this.partnerZoom = 13,
	this.icon = '/images/marker.png',
	this.startLatLng;
	this.markers = [];
	this.fix = 10;

	this.initMap = function() {
		me.startLatLng = new google.maps.LatLng(51.9189046,19.1343786);
		me.map = new google.maps.Map(document.getElementById('distributors__map'), {
			zoom: me.startZoom,
			center:  me.startLatLng,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			scrollwheel: false,
			icon: me.icon
		});
	};


	this.addMarkersToMapAll = function () {
		me.removeMarkers();
		var locations = new Array();
		$('.js-distributors__boxesItem').each(function(){
			latlng = $(this).attr("data-position").split(',');
			locations.push([latlng[0], latlng[1]]);
		});
		me.addMarkers(locations);
	};

	this.removeMarkers = function () {
		//remove all markers from map and memory
		for (var i = 0; i < me.markers.length; i++) {
			me.markers[i].setMap(null);
		}
		me.markers = [];
	};

	this.addMarkersToMap = function () {
		me.removeMarkers();
		// set locations for markers
		var locations = new Array();
		var divs = $('.js-distributors__boxesItem:visible');
		$(divs).each(function() {
			latlng = $(this).data('position').split(',');
			locations.push([latlng[0], latlng[1]]);
		});
		me.addMarkers(locations);
	};

	this.addMarkers = function(locations) {
			// add markers to map
			for (i = 0; i < locations.length; i++) {
				var marker = new google.maps.Marker({
					position: new google.maps.LatLng(locations[i][0], locations[i][1]),
					map: me.map,
					icon: me.icon

				});
				me.markers.push(marker); // and remember them
				// if marker clicked => show info
				var infowindow = new google.maps.InfoWindow();
				google.maps.event.addListener(marker, 'click', (function(marker, i) {
					return function() {
						//infowindow.setContent(findInfoForMarker(marker));
						//infowindow.setContent(locations[i][0]);
						//infowindow.open(map, marker);
					}
				})(marker, i));
			}
	};

	me.addMarkersToMapAll();

	this.findMarker = function (lat, lng) {
		var fix = 10;
		lat = parseFloat(lat).toFixed(fix);
		lng = parseFloat(lng).toFixed(fix);
		//console.log('finding latlng: '+lat+' '+lng);
		for (i = 0; i < me.markers.length; i++) {
			if (me.markers[i].getPosition().lat().toFixed(fix) == lat && me.markers[i].getPosition().lng().toFixed(me.fix) == lng) {
				//console.log('marker '+i+' latlng: '+markers[i].getPosition().lat()+" "+markers[i].getPosition().lng());
				return me.markers[i];
			}
		}
		return null;
	};

	this.changeSelect = function (value, element) {
		if ($('.distributors').length>0) { //
				var ll = element.data('value');
				if (typeof ll !== "undefined") {
					var latlng = ll.split(','),
					zoom = $(element).data('zoom');

					var ops = element.data('value');  //select latlng
					var opt_name = element.text();
					var opt_province = element.text();
					var selectClass = element[0].parentNode.parentElement.classList[1];

					if (selectClass == 'distributors__selectProvince') {
						$('.js-distributors__select select')[1].selectize.clear();
						$('#distributors__selectCity').selectize()[0].selectize.enable();

						stateLatLng = (latlng.length == 2) ? new google.maps.LatLng(latlng['0'], latlng['1']) : startLatLng;
						stateZoom = (zoom) ? zoom : me.globalStateZoom;
						me.map.panTo(stateLatLng);
						me.map.setZoom(8);
					} else if (selectClass == 'distributors__selectCity') {
						townLatLng = (latlng.length == 2) ? new google.maps.LatLng(latlng['0'], latlng['1']) : startLatLng;
						townZoom = (zoom) ? zoom : me.globalStateZoom;
						me.map.panTo(townLatLng);
						me.map.setZoom(11);
					}


					$('.js-distributors__boxesItem').each(function(){
						$(this).removeClass('active').hide();
						if ($(this).data('province').toLowerCase()==opt_province.toLowerCase()) {
							$(this).show();
						} else if ($(this).data('city').toLowerCase()==opt_name.toLowerCase()) {
								$(this).show();
						}

						if($(this).data('position')==ll) {
							//$(this).addClass('active-member');
						}

					});

					// change map position and zoom
					me.addMarkersToMap();
					townLatLng = (latlng.length == 2)?new google.maps.LatLng(latlng['0'], latlng['1']):startLatLng;
					townZoom = (zoom)?zoom:me.globalStateZoom;
					me.map.panTo(townLatLng);
					//map.setZoom(11);

				}
			}
	};

	me.bindEvents = function(){
		$(document).on('click', '.js-distributors__boxesItem', function(e) {
			e.preventDefault();
			var latlng = $(this).attr('data-position').split(','),
				latLngObj = new google.maps.LatLng(latlng['0'], latlng['1']);

			// show info window
			google.maps.event.trigger(me.findMarker(latlng['0'], latlng['1']), 'click');
			// change map center position
			me.map.panTo(latLngObj);
			me.map.setZoom(15);
			$('html, body').animate({
					scrollTop: $('.distributors__map').offset().top - 150
			}, 600);

			$(this).addClass('active').siblings().removeClass('active');
		});

		$('.distributors__boxesInfo a:not(.distributors__boxesHow)').click(function( event ) {
			event.stopPropagation();
		});

		var options = $("#distributors__selectProvince option");
		var selectizeOptions = new Array();
		for(var i=0; i<options.length;i++){
			if(options.eq(i).text()!=""){
				selectizeOptions.push({
					"dataProvince": options.eq(i).text(),
					"dataPlacement": options.eq(i).val()
				});
			}
		}

		if ($('.distributors').length) {
			$('#distributors__selectProvince').selectize({
				valueField: 'dataPlacement',
				labelField: 'dataProvince',
				searchField: ['dataProvince'],
				sortField: 'dataProvince',
				sortDirection: 'desc',
				maxItems: 1,
				options: selectizeOptions,
				create: false,
				render: {
					option: function(item, escape) {
						return '<div class="option" data-province="'+ escape(item.dataProvince) + '">'+ escape(item.dataProvince) + '</div>';
					}
				},
				onItemAdd: function(value, $item) {
					me.changeSelect(value,$item);
				},
			});


		  selectizeOptions = new Array();
		  options = $(".js-distributors__boxesItem");
		  for(var i=0; i<options.length;i++){
		      selectizeOptions.push({
		        "dataProvince": options.eq(i).attr('data-province'),
		        "dataCity": options.eq(i).attr('data-city'),
		        "dataPlacement": options.eq(i).attr('data-position')
		      });
		  }


		  $('#distributors__selectCity').selectize({
				valueField: 'dataPlacement',
				labelField: 'dataCity',
				sortDirection: 'desc',
				maxItems: 1,
				options: selectizeOptions,
				sortField: 'dataCity',
				sortDirection: 'desc',
				create: false,
				render: {
					option: function(item, escape) {
						return '<div class="option" data-province="'+ escape(item.dataProvince) + '">'+ escape(item.dataCity) + '</div>';
					}
				},
				onItemAdd: function(value, $item) {
					me.changeSelect(value,$item);
				},
				onDropdownOpen: function($dropdown) {
					var province = $('.distributors__selectProvince .item').text();
					setTimeout(function(){
						$('.distributors__selectCity .selectize-dropdown-content div').each(function(){
							if ( $(this).attr('data-province') == province ) {
								$(this).addClass('visible');
							}
						});
					},300);
				}
			});

			$('#distributors__selectCity').selectize()[0].selectize.disable();

			$('.js-distributors__selectClear').on('click', function(){
				$('.js-distributors__select select')[0].selectize.clear();
				$('.js-distributors__select select')[1].selectize.clear();
				me.initMap();
				me.addMarkersToMapAll();
				$('.js-distributors__boxesItem').show();
			});
		}
	};

};

$(document).ready(function(){
	if ($('.distributors').length>0) {
		multimap.initMap();
		multimap.addMarkersToMapAll();
	}
	multimap.bindEvents();
});
